export var STATUS_ICON_NAMES = {
  info: 'info',
  success: 'check-mark',
  error: 'exclamation-mark',
  warning: 'exclamation-mark'
};